/**
 * Champions Dashboard - Direct Messaging Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard/messages
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { DirectMessaging } from '../../components/champions/dashboard/DirectMessaging';

export function ChampionsMessagingPage() {
  // TODO: Replace with actual Champion data from backend/store
  const championName = 'Sarah Johnson';
  const championNumber = 3;

  return (
    <ChampionsDashboardLayout championName={championName} championNumber={championNumber}>
      <DirectMessaging />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsMessagingPage;
